import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "web-assistant-launcher" }


export default /*@__PURE__*/_defineComponent({
  __name: 'WebAssistantLauncher',
  props: {
  isOpen: {
    type: Boolean,
    required: true,
  },
  backgroundColour: {
    type: String,
  },
  iconColour: {
    type: String,
  },
},
  emits: ["buttonClick"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "web-assistant-launcher__button",
      style: _normalizeStyle({ backgroundColor: __props.backgroundColour }),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('buttonClick')))
    }, [
      (!__props.isOpen)
        ? (_openBlock(), _createElementBlock("svg", {
            key: 0,
            class: "app-icon",
            style: _normalizeStyle({ fill: __props.iconColour })
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("use", {
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              "xlink:href": "#web-assistant"
            }, null, -1)
          ]))], 4))
        : (_openBlock(), _createElementBlock("svg", {
            key: 1,
            class: "close-icon",
            style: _normalizeStyle({ stroke: __props.iconColour })
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("use", {
              "xmlns:xlink": "http://www.w3.org/1999/xlink",
              "xlink:href": "#cross"
            }, null, -1)
          ]))], 4))
    ], 4)
  ]))
}
}

})